var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#A6B0CF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8.5,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 10.5,
    x2: 6.5,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8,
    y1: 8.2,
    x2: 14.5,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 6.5,
    x2: 14.5,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 6.5,
    x2: 14.5,
    y2: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/Gender.befc74aa.svg";
export { ForwardRef as ReactComponent };